
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { CodeListDataDto } from "./all-code-list-data-model";


export class AllCodeListDataResponse extends GlobalResponseObject {
    data?: CodeListDataDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CodeListDataDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

